import AtomicPaymentPlan from "../../../../src/courses/partials/atomic/payment-plan.mdx";
import * as React from 'react';
export default {
  AtomicPaymentPlan,
  React
};